<template>
<div>

    <design-2021-lesson-show-slide-text-component v-if="slideIn.type === 1" :slide-in="slideIn" ></design-2021-lesson-show-slide-text-component>
    <design-2021-lesson-show-slide-video-component v-else-if="slideIn.type === 2" :slide-in="slideIn" ></design-2021-lesson-show-slide-video-component>
    <design-2021-lesson-show-slide-list-component v-else-if="slideIn.type === 3" :slide-in="slideIn" @slide-updated="slideUpdated($event)" ref="slideList"></design-2021-lesson-show-slide-list-component>
    <design-2021-lesson-show-slide-list-named-component v-else-if="slideIn.type === 4" :slide-in="slideIn" ref="slideNamedList"></design-2021-lesson-show-slide-list-named-component>
    <design-2021-lesson-show-slide-generator-component v-else-if="slideIn.type === 6" :slide-in="slideIn"></design-2021-lesson-show-slide-generator-component>

</div>
</template>

<script>
    export default {
        name: "design-2021-lesson-show-slide-component",
        props: ['slideIn'],
        methods: {
            slideUpdated(slide) {
                this.$emit('slide-updated', slide);
            },
            onClickAddRow() {
                if(this.slideIn.type == 3)
                {
                    this.$refs.slideList.onClickAddRow();
                }
            },
            onClickSwitchSingleDouble() {
                if(this.slideIn.type == 3)
                {
                    this.$refs.slideList.onClickSwitchSingleDouble();
                }
                else if(this.slideIn.type == 4)
                {
                    this.$refs.slideNamedList.onClickSwitchSingleDouble();
                }
            }
        }
    }
</script>

<style scoped>

</style>
